/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <div class="store_login_unit">{{brandStoreName}}</div>
        <div class="admin_menu_top_unit menu_center">

            <Message v-if="ApivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
            <Message :validationMessage="ApivalidationMessage" />

            <form class="form_staff" v-on:submit.prevent="onsubmit">
                <div class="lavel_staff right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="authorityKbnSet">管理者区分</label>
                </div>
                <div class="input_staff left_comment" id="authorityKbnSet">
                    <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" id="authorityKbnSet1" type="radio" value='7' v-model.number="addstaffForm.authority_kbn">
                        <label class="form-check-label" for="authorityKbnSet1">スタッフ</label>
                    </div>
                    <div class="form-check form-check-inline wd70">
                        <input class="form-check-input display_radio" id="authorityKbnSet2" type="radio" value='4' v-model.number="addstaffForm.authority_kbn">
                        <label class="form-check-label" for="authorityKbnSet2">店舗管理者</label>
                    </div>
                    <br>
                    <label id="authorityKbnSet_err1" class="lavel_error_font ">{{validation.authorityKbnResult}}</label>
                </div>
                <div class="lavel_staff right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label  for="staff_name">氏名</label>
                </div>
                <div class="input_staff left_comment">
                    <input  class="wd240" id="staff_name" name="name" type="text" v-model="addstaffForm.staff_name"  maxlength="20" /><br>
                    <label id="nameerror" class="lavel_error_font ">{{validation.staffnameReult}}</label>
                </div>

                <div class="lavel_staff right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label  for="staff_name_furigana">ふりがな</label>
                </div>
                <div class="input_staff left_comment">
                    <input  class="wd240" id="staff_name_furigana" name="namefuri" type="text" v-model="addstaffForm.staff_name_furigana"  maxlength="20" /><br>
                    <label id="namefurierror" class="lavel_error_font ">{{validation.staffnamefuriganaReult}}</label>
                </div>
            </form>
        </div>
        <div class="btn_submit letter_spa">
            <a href="#" @click.prevent.stop="checkFrom">登録</a>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">スタッフ登録</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>スタッフ登録が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import ValidationRule from '@/app/config/validationRule.js'
    import Message from '@/app/components/Message.vue'
export default {
    name: 'StaffAdd',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            isLoading: false,
            showContent:false,
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            addstaffForm: {
                staff_name: null,
                staff_name_furigana: null,
                authority_kbn:7,
            },
            validation:{
                staffnameReult: "",
                staffnamefuriganaReult: "",
                authorityKbnResult: "",
            },
            addFormFlg: true
        }
    },
    computed:{
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        brandStoreName: function () {
            let brandName = this.$store.getters['brand/name']
            let storeName = this.$store.getters['store/name']

            if (brandName == null) {
                brandName = ''
            }

            if (storeName == null) {
                storeName = ''
            }

            return brandName + '・' + storeName
        },
    },
    methods:{
        checkFrom:async function(){

            this.isLoading = true;
            this.addFormFlg = true;

            //エラー内容初期化
            this.clearError();

            //バリデーションチェック(企業コード)
            //必須チェック
            if(!this.addstaffForm.staff_name){
                this.validation.staffnameReult="氏名を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.addstaffForm.staff_name_furigana){
                this.validation.staffnamefuriganaReult="ふりがなを入力してください。"
                this.addFormFlg = false;
            }
            if(this.addstaffForm.authority_kbn == null){
                this.validation.authorityKbnResult="管理者区分を選択してください。"
                this.addFormFlg = false;
            }


            //桁数チェック
            if(String(this.addstaffForm.staff_name).length > 20 && this.validation.staffnameReult == ""){
                this.validation.staffnameReult="氏名は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.addstaffForm.staff_name_furigana).length > 20 && this.validation.staffnamefuriganaReult == ""){
                this.validation.staffnamefuriganaReult="ふりがなは20桁以内で入力してください。"
                this.addFormFlg = false;
            }


            //文字種チェック
            if(this.addstaffForm.staff_name !== null && !this.checkStrong2(this.addstaffForm.staff_name) && this.validation.staffnameReult == ""){
                this.validation.staffnameReult="氏名は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addstaffForm.staff_name_furigana !== null && !this.checkStrong6(this.addstaffForm.staff_name_furigana) && this.validation.staffnamefuriganaReult == ""){
                this.validation.staffnamefuriganaReult="ふりがなは全角ひらがな記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.addstaffForm.authority_kbn != 7 && this.addstaffForm.authority_kbn != 4 ){
                this.validation.authorityKbnResult="管理者区分の値の形式が正しくありません。"
                this.addFormFlg = false;
            }

            // バリデーション
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            if(this.addFormFlg == true){

                // 企業ブランドIDの取得
                this.brandId = this.$store.getters['brand/id'];
                // 店舗IDの取得
                this.storeId = this.$store.getters['store/id'];
                var url = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId + '/staff/register';

                this.ApivalidationMessage = '';
                var apiResponseFlg = true;

                // DBデータ取得
                await this.$axios
                    .post(url,{staff_name:this.addstaffForm.staff_name,staff_name_furigana:this.addstaffForm.staff_name_furigana, authority_kbn:this.addstaffForm.authority_kbn})
                    .then()
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);
                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            } else if (error.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                // API処理判定
                if(apiResponseFlg){
                    this.openModel();
                }

            }

        },
        //全半角英数漢ひらカナ
        checkStrong2:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuEiSuuKanaKanjiSpace);
            return re.test(inputdata);
        },
        //全半角漢ひらカナ
        checkStrong5:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuKanaKanji);
            return re.test(inputdata);
        },
        //全角ひらがな
        checkStrong6:function(inputdata){
            var re = new RegExp(ValidationRule.ZenkakuHiragana);
            return re.test(inputdata);
        },
        clearError:function(){
            //メッセージ初期化
            this.validation.staffnameReult = "";
            this.validation.staffnamefuriganaReult = "";
            this.ApivalidationMessage = "";
        },
        openModel() {
            this.showContent = true;
        },
        closeModel() {
            this.showContent = false;
            this.$router.push({name: 'staffList', params: {brandPath: this.brandPath,brandId: this.$store.getters['$brand/id'],
                    storeId: this.$store.getters['$store/id']}});
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>